import FacebookIcon from '@mui/icons-material/Facebook';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import WebIcon from '@mui/icons-material/Web';
import LanguageIcon from '@mui/icons-material/Language';
import DnsIcon from '@mui/icons-material/Dns';

export default {
    name:"MD. Shehabuddin Tushar",
    title:"Mern stack developer",

    birthday:"03 july 1995",
    email:"shehabuddin.tushar@gmail.com",
    job:"Freelancer",
    address:"Matuail-Jatrabari-Dhaka",
    phone:"01409-130-405",


    socials:{
        facebook:{
            link:"https://www.facebook.com/md.shehabuddintushar",
            text:"tushar facebook",
            icon:<FacebookIcon/>,
        },

        github:{
            link:"https://github.com/Shehabuddin-Tushar",
            text:"tushar github",
            icon:<GitHubIcon/>,
        },

        Linkedin:{
            link:"https://www.linkedin.com/in/shehabuddintushar-9b07ba171/",
            text:"tushar linkedin",
            icon:<LinkedInIcon/>,
        }


    },

    about:'I am a full stack software developer with more than 5000 hours of building, maintaining and deploying single page/eCommerce applications.\n\n I can adapt on to any technology rapidly making myself flexible upon any tech stack. A passionate, diligent person who wants to learn continuously.',

    projects:[
        {
            projectname:"Automantia",
            projecturl:"https://automantia-authantication.web.app/",
            projectdetails:[
                "Developed an selling based Application using mern stack that allows users to buy car.",
                "Integrated stripe payments to accept credit/debit cards.",
                "Utilized React, material-ui, firebase Authentication, Express , Mongodb."
            ]
        },

        {
            projectname:"I-land Hotel",
            projecturl:"https://i-land-booking-authantication.web.app/",
            projectdetails:[
                "This is a booking website. Where users can book hotels or resorts.",
                "User Can choose, Cancel the Booking through the website.",
                "Utilized React, Tailwind css, firebase Authentication,Express, Mongodb,Heroku."
            ]
        },

        {
            projectname:"Medific",
            projecturl:"https://medific-authantication.web.app/home",
            projectdetails:[
                "This is a medical website.user can see  medical services.",
                "Its a Responsive website .",
                "Utilized React,Tailwind css ,media query,  firebase authentication."
            ]
        }
    ],
    education:[
        {
            degree:"Diploma in Electronics engineering",
            institute:"Dhaka polytechnic institute"
        }
    ],
    additionalcertificate:[
        {
            course:"Web Development(Mern stack)",
            institute:"Programming hero"
        },

        {
            course:"Web Development(Php,Mysql,Laravel)",
            institute:"Bitm(BASIS Institute of Technology & Management)"
        },

        {
            course:"Web Desing and Development",
            institute:"DIIT(Daffodil institute of IT)"
        }
    ],

    skills:[
        {
            title:"FRONT-END",
            description:["ReactJs","JavaScript","Metarial UI","Tailwind Css","Bootstrap"]
        },

        {
            title:"BACK-END",
            description:["NodeJs","ExpressJs","Php","Laravel"]
        },

        {
            title:"DATABASE",
            description:["MongoDb","MySql","Firebase"]
        },

        {
            title:"SOURCE CONTROL",
            description:["Git","Github"]
        },

    ],

    protfolios: [
        {
            title: "Iman-xpress",
            images: ["https://i.postimg.cc/hvcCHJ8P/image222.png", "https://i.postimg.cc/Pq09FrFP/image333.png", "https://i.postimg.cc/kGvH4NMb/image111.png"],
            description: [" Iman xpress has multifeatures. It has ride-sharing services,food delivery,courier and ecommerce services.",
                "Riders and users can chat with each others  by this chatting system",
                "Utilized React, Material-ui, firebase authentication,React-hook-form, Express,Mongodb, Mongoose, bycriptjs, express validation etc."
            ],
            links: [
                { link: "https://iman-xpress-9b3a9.web.app/", icon: <LanguageIcon />, iconname: "Live site" },
                { link: "https://github.com/Shehabuddin-Tushar/iman-express-endgame-group-project", icon: <GitHubIcon />, iconname: "Github client" },
                { link: "https://github.com/Shehabuddin-Tushar/iman-xpress-backend", icon: <GitHubIcon />, iconname: "Github server" }
            ]
        },
        {
           title:"I-land-hotel-project1",
           images:["https://i.postimg.cc/RhPrh5Dv/iland.png","https://i.postimg.cc/c1vH4xLz/iland2.png","https://i.postimg.cc/NF3ZQ7jQ/iland3.png"],
           description:["This is a booking website. Where users can book hotels or resorts.",
                        "User Can choose, Cancel the Booking through the website.",
                        "Utilized React, Tailwind css, firebase Authentication,Express, Mongodb,Heroku."
                       ],
           links:[
               {link:"https://i-land-booking-authantication.web.app/",icon:<LanguageIcon/>,iconname:"Live site"},
               {link:"https://github.com/Shehabuddin-Tushar/hotel-and-resort-clientsite",icon:<GitHubIcon/>,iconname:"Github client"},
               {link:"https://github.com/Shehabuddin-Tushar/hotel-and-resort-serverside",icon:<GitHubIcon/>,iconname:"Github server"}
            ] 
        },

        {
            title:"Automantia-project2",
            images:["https://i.postimg.cc/rmk2Y942/automantia.png",
                    "https://i.postimg.cc/kXzs2gCh/automantia2.png",
                    "https://i.postimg.cc/y6nr8KWw/automantia3.png",
                    "https://i.postimg.cc/CKHsrCqW/automantia4.png",
                    "https://i.postimg.cc/9fjBBgrd/automantia5.png",
                    "https://i.postimg.cc/RZqrBFRs/automantia6.png",
                    "https://i.postimg.cc/0y4T2sX8/automantia7.png",
                    "https://i.postimg.cc/cJ8VvbPf/automantia8.png",
                    "https://i.postimg.cc/zvpMmZRY/automantia9.png",
                ],
            description:["Developed an selling based Application using mern stack that allows users to buy car.",
                         "Integrated stripe payments to accept credit/debit cards.",
                         "Utilized React, material-ui, firebase Authentication, Express , Mongodb."
                        ],
            links:[
                {link:"https://automantia-authantication.web.app/",icon:<LanguageIcon/>,iconname:"Live site"},
                { link:"https://github.com/Shehabuddin-Tushar/Automantia-update-project-client-site",icon:<GitHubIcon/>,iconname:"Github client"},
                { link:"https://github.com/Shehabuddin-Tushar/Automantia-update-server-site",icon:<GitHubIcon/>,iconname:"Github server"}
             ] 
         },

         {
            title:"Medific-project3",
            images:[
                "https://i.postimg.cc/PrrTjKRt/medific.png",
                "https://i.postimg.cc/6QkmKPGm/medific2.png",
                "https://i.postimg.cc/2ym9bBGd/medific3.png",
                "https://i.postimg.cc/Px1F5MWr/medific4.png"
            ],
            description:["This is a medical website.user can see medical services.",
                         "You can log in with Google from this site.",
                        "Utilized React,Tailwind css ,Media query, Firebase authentication."
                        ],
            links:[
                {link:"https://medific-authantication.web.app/",icon:<LanguageIcon/>,iconname:"Live site"},
                {link:"https://github.com/Shehabuddin-Tushar/medific-healthcare-related",icon:<GitHubIcon/>,iconname:"Github client"}
                
             ] 
         },

         {
            title:"LernOn-project4",
            images:[
                "https://i.postimg.cc/BQYsQDr2/lernon.png",
                "https://i.postimg.cc/TPB36T0v/lernon2.png",
                "https://i.postimg.cc/BnQ65Ybk/lernon3.png",
                "https://i.postimg.cc/7ZsLK3T6/lernon4.png"
             ],
            description:["this website for computer courses services.",
                         "You can enrolled from this site.You can contact with us from this website contact Us page.",
                         "You can see our services form service page.Utilized React, material-ui,google map."
                        ],
            links:[
                {link:"https://learn-on.netlify.app/",icon:<LanguageIcon/>,iconname:"Live site"},
                {link:"https://github.com/Shehabuddin-Tushar/learn-on-review-website",icon:<GitHubIcon/>,iconname:"Github client"},
                
             ] 
         },

         {
            title:"Landingpage-project5",
            images:["https://i.postimg.cc/rpWLJHK9/profile.png"],
            description:["This is a creative Personal portfolio template.",
                         "You can use this template for resumes, freelancers, art, illustrations and many others, which will help you to demonstrate all your services, your information, work.",
                        "All files and code are well organized and well documented, and you can quickly and easily customize the template."],
            links:[
                {link:"https://shehabuddin-tushar.github.io/landingpage-demo/",icon:<LanguageIcon/>,iconname:"Live site"},
                {link:"https://github.com/Shehabuddin-Tushar/landingpage-demo",icon:<GitHubIcon/>,iconname:"Github client"}
               
             ] 
         },

         {
            title:"Danceclub-project6",
            images:["https://i.postimg.cc/TwJv8WjL/danceclub.png"],
            description:["this website use for online course",
                         "you can added courses in cart and payment here.",
                         "If you want to make an online shopping site with this site then you can.",
                         "Utilized React,Bootstrap"
                        ],
            links:[
                {link:"https://online-dancing-club.netlify.app/",icon:<LanguageIcon/>,iconname:"Live site"},
                {link:"https://github.com/Shehabuddin-Tushar/online-dancing-training-club-superhero",icon:<GitHubIcon/>,iconname:"Github client"}
                
             ] 
         },

         {
            title:"Newsportal-project7",
            images:[
                "https://i.postimg.cc/YCv7407Z/newspaper.png",
                "https://i.postimg.cc/9XbhF2t9/newsportal2.png",
                "https://i.postimg.cc/Kj0S97vf/newsmobile.png",
                "https://i.postimg.cc/DyzKSNBM/newsportal3.png",
                "https://i.postimg.cc/prWMYcxy/newsportal4.png"
            ],
            description:["This is a newsportal website",
                         "This design and customize wordpress based",
                         "This site has Many different page layout",
                         "Utilized Html,css,Bootstrap,slick nav"],
            links:[
                {link:"https://shehabuddin-tushar.github.io/demo-protfolio/frontpage.html",icon:<LanguageIcon/>,iconname:"Live site"},
                {link:"https://github.com/Shehabuddin-Tushar/demo-protfolio",icon:<GitHubIcon/>,iconname:"Github client"}
                
             ] 
         }
    ]

    
}